// Mock event data for BlackTieDo landing prototype
export const CATEGORIES = [
  { id: "charity-balls", label: "Charity Balls" },
  { id: "business-awards", label: "Business Awards" },
  { id: "highland-balls", label: "Highland Balls" },
];

export const EVENTS = [
  {
    id: "chain-of-hope-gala-ball",
    title: "Chain of Hope Gala Ball",
    category: "charity-balls",
    categoryLabel: "Charity Ball",
    date: "13 November 2026",
    dateISO: "2026-11-13",
    location: "Natural History Museum, London",
    price: "From £395",
    host: "Chain of Hope",
    image:
      "https://images.unsplash.com/photo-1776671069226-24e6d422a61b?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "A gala beneath the whale, in aid of children's cardiac care worldwide.",
    span: "feature",
  },
  {
    id: "argyllshire-gathering-ball",
    title: "The Argyllshire Gathering Ball",
    category: "highland-balls",
    categoryLabel: "Highland Ball",
    date: "26 August 2026",
    dateISO: "2026-08-26",
    location: "Corran Halls, Oban",
    price: "From £245",
    host: "The Argyllshire Gathering",
    image:
      "https://images.unsplash.com/photo-1562050147-fda1cc9a6378?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "Highland dress, reels called by the piper, in continuous residence since 1871.",
  },
  {
    id: "bafta-scotland-awards",
    title: "BAFTA Scotland Awards",
    category: "business-awards",
    categoryLabel: "Business Awards",
    date: "15 November 2026",
    dateISO: "2026-11-15",
    location: "DoubleTree by Hilton, Glasgow",
    price: "From £310",
    host: "BAFTA Scotland",
    image:
      "https://images.unsplash.com/photo-1626814026160-2237a95fc5a0?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "Scotland's screen industries honoured across film, television and games.",
    span: "feature",
  },
  {
    id: "the-macmillan-ball",
    title: "The Macmillan Ball",
    category: "charity-balls",
    categoryLabel: "Charity Ball",
    date: "04 December 2026",
    dateISO: "2026-12-04",
    location: "The Dorchester, London",
    price: "From £250",
    host: "Macmillan Cancer Support",
    image:
      "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "London's most generous winter evening, in aid of Macmillan Cancer Support.",
  },
  {
    id: "northern-meeting-ball",
    title: "The Northern Meeting Ball",
    category: "highland-balls",
    categoryLabel: "Highland Ball",
    date: "03 September 2026",
    dateISO: "2026-09-03",
    location: "The Northern Meeting Rooms, Inverness",
    price: "From £280",
    host: "The Northern Meeting Committee",
    image:
      "https://images.unsplash.com/photo-1543007630-9710e4a00a20?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "Scotland's oldest continuous social gathering - since 1788, and quietly unchanged.",
    span: "feature",
  },
  {
    id: "glasgow-business-awards",
    title: "The Glasgow Business Awards",
    category: "business-awards",
    categoryLabel: "Business Awards",
    date: "01 October 2026",
    dateISO: "2026-10-01",
    location: "The Grand Central Hotel, Glasgow",
    price: "From £145",
    host: "Glasgow Chamber of Commerce",
    image:
      "https://images.unsplash.com/photo-1740120424442-ccd013ec9581?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "The city's enterprise honoured - a black-tie ceremony on the Clyde.",
  },
  {
    id: "james-watt-dinner",
    title: "The James Watt Dinner",
    category: "business-awards",
    categoryLabel: "Business Awards",
    date: "02 October 2026",
    dateISO: "2026-10-02",
    location: "Radisson Blu Hotel, Argyle Street, Glasgow",
    price: "From £95",
    host: "The Institution of Engineers in Scotland",
    image:
      "/james-watt-dinner-2026.jpg",
    tagline:
      "One of the oldest engineering dinners in the world - a dram raised to James Watt, and to Scotland's newest Hall of Fame inductees.",
    span: "feature",
    externalUrl: "https://engineers.scot/events/james-watt-dinner",
  },
  {
    id: "masquerade-ball-tbc",
    title: "The Masquerade Ball",
    category: "coming-soon",
    categoryLabel: "Preview",
    date: "TBC 2027",
    dateISO: "2027-01-01",
    location: "Venue To Be Announced",
    price: "",
    host: "",
    image:
      "https://images.unsplash.com/photo-1585307128327-8d3436f289eb?auto=format&fit=crop&w=1600&q=80",
    tagline:
      "A night behind the gilded mask. Details will follow.",
    placeholder: true,
  },
];

export const MANIFESTO = [
  {
    number: "01",
    kicker: "Origin",
    title: "A door, not a directory.",
    body:
      "BlackTieDo was founded on the belief that the finest evenings of the British calendar deserve more than a listing. We are the corridor between the invitation and the door - quietly, precisely, and by design.",
    image:
      "https://images.pexels.com/photos/17697795/pexels-photo-17697795.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
  },
  {
    number: "02",
    kicker: "Curation",
    title: "Chosen. Never listed.",
    body:
      "Each ball, gala, and ceremony on the portal is vetted against a single standard: would we go? Our editors travel, dine, and attend, so that when your evening begins it has already been considered on your behalf.",
    image:
      "https://images.unsplash.com/photo-1522968439036-e6338d0ed84f?auto=format&fit=crop&w=1600&q=80",
  },
  {
    number: "03",
    kicker: "Discretion",
    title: "Black tie, without the noise.",
    body:
      "No leaderboards, no reviews, no crowds. BlackTieDo is built for those who prefer the whisper to the announcement - and who understand that the best rooms are the quiet ones.",
    image:
      "https://images.unsplash.com/photo-1580657274234-7339717f4541?auto=format&fit=crop&w=1600&q=80",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "The single most useful thing to happen to the London social calendar in a decade.",
    name: "Harriet Ashcombe",
    role: "Editor-at-Large, Country & Town",
  },
  {
    quote:
      "We used to keep a black book. We keep BlackTieDo bookmarked instead.",
    name: "Ivo Cranleigh",
    role: "Partner, Cranleigh & Vale",
  },
  {
    quote:
      "Refined, quiet, and impeccably judged - exactly the tone the sector required.",
    name: "The Duchess of Ellingham",
    role: "Patron, The Highgrove Ball",
  },
];

// Press masthead logos rendered as clean high-contrast SVG wordmarks.
export const PRESS = [
  { id: "vogue", name: "Vogue" },
  { id: "tatler", name: "Tatler" },
  { id: "the-times", name: "The Times" },
  { id: "conde-nast-traveller", name: "Condé Nast Traveller" },
];

export const PRESS_QUOTE = {
  quote: "The Season is the definitive authority for the UK formal calendar.",
  source: "Vogue Editorial",
};

// Long-standing societies BlackTieDo curates on behalf of. Text-only,
// grouped, and deliberately understated in the footer.
export const PATRONS = [
  {
    heading: "Scottish & Highland",
    societies: [
      "The Caledonian Society of London",
      "The London Highland Club",
      "The Royal Scottish Corporation",
      "The Society of St Andrew",
      "The Perthshire Association",
    ],
  },
  {
    heading: "Regional Associations",
    societies: [
      "The Cornish Association of London",
      "The Yorkshire Society",
      "The Durham Society",
      "The Devonshire & Somerset Committee",
      "The Anglo-Irish Circle",
    ],
  },
  {
    heading: "Livery & Heritage",
    societies: [
      "The Worshipful Company of Vintners",
      "The Royal Overseas League",
      "The Beefsteak Committee",
      "The Society of Merchant Adventurers",
      "The Corinthian Sailing Society",
    ],
  },
];
